import { channels } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

const channelImgs = [
  "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20stage%20spotlight%20with%20microphone%20and%20confetti%2C%20playful%20entertainment%20show%20theme%2C%20cream%20and%20soft%20green%20background%2C%20warm%20minimalist%20cartoon%20style%2C%20clean%20and%20cheerful%2C%20no%20text&width=800&height=600&seq=ch-mic-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20two%20chat%20bubbles%20shaped%20like%20hearts%20and%20melons%2C%20romantic%20gossip%20theme%2C%20soft%20pink%20and%20cream%20background%2C%20warm%20minimalist%20cartoon%20style%2C%20clean%20and%20sweet%2C%20no%20text&width=800&height=600&seq=ch-heart-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20cozy%20office%20desk%20with%20laptop%20coffee%20and%20sticky%20notes%2C%20workplace%20fun%20theme%2C%20cream%20and%20soft%20green%20background%2C%20warm%20minimalist%20cartoon%20style%2C%20clean%20and%20friendly%2C%20no%20text&width=800&height=600&seq=ch-work-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20delicious%20noodles%20and%20bubble%20tea%20with%20steam%2C%20street%20food%20theme%2C%20warm%20cream%20and%20soft%20yellow%20background%2C%20minimalist%20cartoon%20style%2C%20clean%20appetizing%20and%20cheerful%2C%20no%20text&width=800&height=600&seq=ch-food-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20people%20chatting%20in%20a%20city%20park%20with%20newspaper%20and%20balloons%2C%20social%20fun%20news%20theme%2C%20cream%20and%20soft%20green%20background%2C%20warm%20minimalist%20cartoon%20style%2C%20clean%20and%20lively%2C%20no%20text&width=800&height=600&seq=ch-news-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20cute%20cat%20knocking%20over%20things%20and%20chasing%20a%20watermelon%2C%20silly%20daily%20life%20theme%2C%20cream%20and%20soft%20peach%20background%2C%20playful%20minimalist%20cartoon%20style%2C%20clean%20and%20hilarious%2C%20no%20text&width=800&height=600&seq=ch-fun-01&orientation=landscape",
];

export default function Channels() {
  return (
    <section id="channel" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <SectionHeading
            kicker="频道分类 · 按频道吃瓜"
            title="想吃哪口瓜，就到哪层楼"
            desc="我们把神回复和名场面按兴趣频道归档，娱乐现场、情感八卦、职场打工人……挑个频道开逛，笑点一抓一大把。"
          />
          <span className="w-fit whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-600">
            共 {channels.reduce((s, c) => s + c.count, 0).toLocaleString()} 条精选评论
          </span>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((c, i) => (
            <article
              key={c.name}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-sm"
            >
              <div className="relative h-36 overflow-hidden md:h-40">
                <img
                  src={channelImgs[i]}
                  alt={`${c.name}频道`}
                  title={`${c.name}频道神评名场面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex h-10 w-10 items-center justify-center rounded-full bg-background-50/95 text-xl text-primary-600 shadow-sm">
                  <i className={c.icon}></i>
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-900">{c.name}</h3>
                  <span className="whitespace-nowrap text-xs text-foreground-500">{c.count} 条神评</span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <a
                  href="#reply"
                  className="mt-3 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors group-hover:text-primary-700"
                >
                  去逛这个频道
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}